var React = require('react');

function NavigationClose (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"rotate(-45 14.828 5.172)","fill":"current","fillRule":"evenodd"},[React.createElement("rect",{"y":"7","width":"16","height":"2","rx":"1","key":0}),React.createElement("rect",{"transform":"rotate(90 8 8)","y":"7","width":"16","height":"2","rx":"1","key":1})]));
}

NavigationClose.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = NavigationClose;

NavigationClose.default = NavigationClose;
